export default {
    price: 6000,
    hasCustomBackground: true,
    light: {
        primary: '#E963D2',
        secondary: '#424242',
        accent: '#4D331A'
    },
    dark: {
        primary: '#EF8FDF',
        secondary: '#424242',
        accent: '#604020'
    }
}
